<template>
  <div class="task-content-start slide">
    <div class="packet-title">
      <div class="demo-title">
        <h3>ЖИШЭЭ БАГЦ: {{ classify[category - 1].text }}</h3>
      </div>
    </div>
    <div class="task-level-list">
      <div
        :class="{ 'router-link': true }"
        v-for="(negLevel, index) in levels.taskLevelArray"
        :key="index"
      >
        <div
          class="test-card"
          :class="{
            locked: negLevel.isLocked,
            'test-one': index === 7,
            'test-two': index === 15,
            'test-three': index === 23,
            'card-second': index > 7,
            'card-third': index > 15,
          }"
        >
          <b-link
            class="card-btn"
            :disabled="negLevel.isLocked"
            :to="{
              name: choice[levels.taskLevelArray[index].type],
              params: { lid: negLevel.order },
            }"
          >
            <div
              :class="{
                'task-number': levels.taskLevelArray[index].type === 0,
                'test-title': levels.taskLevelArray[index].type === 1,
              }"
            >
              <span
                v-if="levels.taskLevelArray[index].type === 1"
                :class="{
                  test1: index === 7,
                  test2: index === 15,
                  test3: index === 23,
                }"
              >
                <a>СОРИЛ {{ levels.taskLevelArray[index].order }}</a></span
              >

              <a> {{ levels.taskLevelArray[index].order }} </a>
            </div>
            <img src="../assets/images/lock.png" class="lock" />

            <div class="star-container">
              <div v-for="(i, index) in rating" :key="index">
                <b-icon
                  :class="{
                    'red-star': i === 1 || i === 2,
                  }"
                  :icon="ic_on[i]"
                ></b-icon>
              </div>
            </div>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["levels"],
  data() {
    return {
      rating: [0, 0, 0],
      ic_on: ["star", "star-half", "star-fill"],
      category: 1,
      choice: ["TaskDemo", "Test"],
      classify: [
        { text: "1-2-р анги" },
        { text: "3-4-р анги" },
        { text: "5-6-р анги" },
        { text: "7-8-р анги" },
        { text: "9-10-р анги" },
        { text: "11-12-р анги" },
      ],
      starColor: "#FF3D00",
    };
  },
  methods: {},

  mounted() {
    if (this.$route.params.cid !== undefined) {
      this.category = this.$route.params.cid;
      localStorage.setItem("category", this.category);
    } else {
      this.category = JSON.parse(localStorage.getItem("category"));
    }
  },
};
</script>

<style lang="postcss" scoped>
.task-content-start {
  position: relative;
  width: 95.95%;
  margin-left: auto;
  margin-right: auto;
  font-family: "Roboto", sans-serif;
  padding: 30px 50px 80px 50px;
}
.task-level-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.task-level-list:hover {
  text-decoration: none;
}

.card-btn {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.router-link {
  width: 11.01%;
  text-decoration: none;
  margin: 10px;
  position: relative;
  cursor: pointer;
}
.task-number {
  font-size: 3em;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  -webkit-text-stroke-width: 2px;
  -webkit-text-stroke-color: #636e72;
  width: 80%;
  text-align: start;
}
.test-number {
  font-size: 1em;
}
.score {
  color: #8395a7;
}

.list-score-count {
  font-size: 1.9375em;
  font-family: roboto;
  color: #ffffff;
  padding-bottom: 35px;
}

/*router test*/
.test-card {
  display: flex;
  background-color: #f18719;
  border-radius: 3.75em;
  border: 8px solid #ffffff;
  max-height: 190px;
  max-width: 190px;
}
.test1 {
  color: #f18719;
}
.test2 {
  color: #69b644;
}
.test3 {
  color: #26a3db;
}
.card-second {
  background-color: #69b644;
}
.card-third {
  background-color: #26a3db;
}
.test-one {
  background-color: #ff8200;
}
.test-two {
  background-color: #22b353;
}
.test-three {
  background-color: #0085c1;
}
.test-card.locked {
  background-color: gainsboro;
}
.test-title {
  width: 100%;
  height: 70px;
  text-align: center;
}
.test-title span {
  display: flex;
  justify-content: center;
}
.test-title > a {
  opacity: 0;
}
.test-title > span > a {
  width: 80%;
  font-size: 1.3em;
  background-color: #ffffff;
  border-radius: 100%;
  padding: 10px;
  margin-top: -12px;
  margin-bottom: 7px;
}
.star-container {
  width: 80%;
  padding: 0px 10px 0px 10px;
  font-size: 1.8em;
  display: flex;
  justify-content: space-around;
  border-radius: 100%;
  background-color: #ffffff;
  color: #d1d3d5;
}
.res-star {
  color: red;
}

.lock {
  display: flex;
  justify-content: center;
  margin: -5px 10px 25px 10px;
  visibility: hidden;
  max-width: 40px;
}
.test-card.locked .lock {
  visibility: visible;
}
</style>
